import * as yup from 'yup';

export const newSolicitudTransferenciaSchemaOT = yup.object({
  bodega_origen: yup.string().required('Campo Requerido'),
  ubicacion_origen: yup
    .number()
    .required('Campo Requerido')
    .typeError('No es un número válido'),

  bodega_destino: yup.string().required('Campo Requerido'),

  // ya no va, va ubicacion_destino
  // ubicacion_externa: yup
  //   .number()
  //   .required('Campo Requerido')
  //   .typeError('No es un número válido'),

  concepto: yup.string().required('Campo Requerido'),
  motivo: yup.string().required('Campo Requerido'),

  fecha_solicitud_transferencia: yup.string().required('Campo Requerido'),
});
